<template>
  <Modal
    :title="$t('customize_cta_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('text')"
      name="call_to_action_text"
    >
      <TextInput
        v-model="form.call_to_action_text"
        name="call_to_action_text"
      />
    </InputGroup>

    <InputGroup
      :label="$t('url')"
      name="url"
    >
      <TextInput
        v-model="form.content_url"
        name="content_url"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
import type { CTABlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<CTABlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  call_to_action_text: data.value.item.text,
  content_url: data.value.item.url
})
</script>
